<template>
    <div class="_action sub_page">
        <section class="sub_page_con wrap_1120">
            <div class="state_wrap">
                <ul class="state_list" v-if="state.list.length > 0">
                    <li @click="selectWeek(item.idx)" v-for="item in state.list">
                        <div class="state_status">
                            <p class="ing" v-if="item.state === 1">진행중</p>
                            <p class="end" v-else>종료</p>
                            <p class="remaining_time" v-if="new Date() < new Date(item.endDate)">
                                {{ CommonUtils.getDDayHour(new Date(item.endDate)) }}
                            </p>
                        </div>
                        <p class="state_title">{{ item.name }}</p>
                        <p class="state_create_date">등록일 : {{ CommonUtils.dateFormat(new Date(item.createDate), ".", false) }}</p>
                        <div class="state_info">
                            <p>
                                <label for="">활동기간</label>
                                {{ CommonUtils.dateFormat(new Date(item.startDate), ".", false) }} ~
                                {{ CommonUtils.dateFormat(new Date(item.endDate), ".", false) }}
                            </p>
                            <p>
                                <label for="">액션활동</label>
                                {{ item.cntEntire }} 명 참여
                            </p>
                            <p>
                                <label for="">게시글 수</label>
                                {{ item.cntBoard }}개
                            </p>
                        </div>
                    </li>
                </ul>
                <div class="tr_div" v-else>
                    <div class="tb_subject" style="text-align: center; width: 100%">등록된 액션 활동이 없습니다.</div>
                </div>
            </div>
        </section>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
    ></ModalDefault>
</template>

<script lang="ts" config>
    import {
        reactive,
        onMounted,
        router,
        apiService,
        types,
        CommonUtils,
        PageBtn,
        userStore,
        ModalDefault,
        getMessageByCode,
        onBeforeMount,
    } from "@/BaseComponent";

    export default {
        components: { PageBtn, ModalDefault },
        emits: ["selectState"],
        setup(props: any, { emit }: any) {
            const user = userStore();
            const state = reactive({
                tab: 0 as number,
                list: [] as Array<types.ResBoardStateVOForApi>,
                searchType: "" as string,
                searchText: "" as string,

                page: 1 as number,
                size: 100 as number,
                totalPage: 1 as number,
                totalLength: 3 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isMobile: false,
                hasAuth: false,
                isActive: false,
            });

            onBeforeMount(() => {
                hasAuth();
            });

            onMounted(() => {
                hasAuth();
                getList();

                state.isMobile = window.innerWidth < 768;
            });

            const getList = async () => {
                const res = await apiService.boardAction.stateList();
                if (res.returnCode === 0) {
                    state.list = res.list;
                } else {
                    state.list = [];

                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                    state.isActive = false;
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const hasAuth = () => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin == true &&
                            user.roles != null &&
                            user.roles.some((item: types.RoleVO) => item.key.indexOf("activity") > -1)) ||
                        user.userInfo.hasAuth)
                )
                    state.hasAuth = true;
            };

            const selectWeek = (idx: number) => {
                emit("selectState", idx);
            };

            return { state, router, handlePageChange, getList, CommonUtils, closeModal, hasAuth, selectWeek };
        },
    };
</script>
